'use strict';

/*global app*/
/*global isEmpty*/
/*global invokeCallback*/

function PrintingService() {
  this.$container = $('body');

  this.init();
}

PrintingService.prototype = $.extend({}, {
  constructor: 'PrintingService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  printCustomerLabels: function printCustomerLabels(webDocumentRID, onlyUnpacking) {
    var _this = this;

    app.getFormation('printing:customer_labels', { WebDocumentRID: webDocumentRID, OnlyUnpacking: (onlyUnpacking || false ? 1 : 0) }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewPrintMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  printCustomerLabel: function printCustomerLabel(webDocumentItemRID, amount) {
    var _this = this;

    app.getFormation('printing:customer_label', { WebDocumentItemRID: webDocumentItemRID, Amount: amount }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewPrintMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  printKanbanLabels: function printKanbanLabels(webDocumentRID) {
    var _this = this;

    app.getFormation('printing:kanban_labels', { WebDocumentRID: webDocumentRID }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewPrintMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  printKanbanLabel: function printKanbanLabel(webDocumentItemRID, amount, numOfStickers) {
    var _this = this;

    app.getFormation('printing:kanban_label', { WebDocumentItemRID: webDocumentItemRID, Amount: amount, NumOfStickers: numOfStickers }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewPrintMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  printAddressLabel: function printAddressLabel(handlingUnit) {
    var _this = this;

    app.getFormation('printing:address_label', { HandlingUnit: handlingUnit }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewPrintMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  printArticle: function printArticle(articleId, type, callback) {
    var _this = this;

    app.getFormation('printing:article', { ArticleId: articleId, Type: type }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewPrintMessage();

        return invokeCallback(callback, true);
      } else {
        app.viewErrorMessage(res.error);

        return invokeCallback(callback, false);
      }
    });

    return _this;
  },

  printSizeArticleEan: function printSizeArticleEan(webDocumentItemRID, size, params, callback) {
    var _this = this;
    app.getValue(app.t('printing.article_ean') + ' ' + app.t('printing.count_of_copies'), function (count) {
      if (isEmpty(count)) {
        return invokeCallback(callback, false);
      }

      app.getFormation('printing:article_ean', { WebDocumentItemRID: webDocumentItemRID, Count: count, Size: size, Package: params.Package, SerialNumber: params.SerialNumber, SerialNumberSize: params.SerialNumberSize }, function (res) {
        if (res.msg === 'SUCCESS') {
          app.viewPrintMessage();

          return invokeCallback(callback, true);
        } else {
          app.viewErrorMessage(res.error);

          return invokeCallback(callback, false);
        }
      });
    });

    return _this;
  },

  printSmallArticleEan: function printSmallArticleEan(webDocumentItemRID, params, callback) {
    var _this = this;

    _this.printSizeArticleEan(webDocumentItemRID, 'small', params, callback);

    return _this;
  },

  printBigArticleEan: function printBigArticleEan(webDocumentItemRID, params, callback) {
    var _this = this;

    _this.printSizeArticleEan(webDocumentItemRID, 'big', params, callback);

    return _this;
  },

  printArticleEan: function printArticleEan(webDocumentItemRID, params, callback) {
    var _this = this;

    if (params.SerialNumberSize) {
      return _this.printSizeArticleEan(webDocumentItemRID, params.SerialNumberSize, params, callback);
    }

    var list = [];
    if ($.inArray('small', app.param('article_ean_sizes')) >= 0) {
      list.push({ id: 'small', abbr: app.t('small_label') });
    }

    if ($.inArray('big', app.param('article_ean_sizes')) >= 0) {
      list.push({ id: 'big', abbr: app.t('big_label') });
    }

    if (list.length === 0) {
      return invokeCallback(callback);
    }

    if (list.length > 1) {
      app.selectValue({ list: list }, function (value) {
        switch (value) {
          case 'small' : return _this.printSmallArticleEan(webDocumentItemRID, callback);
          case 'big' : return _this.printBigArticleEan(webDocumentItemRID, callback);
        }
      });
    } else {
      _this.printSizeArticleEan(webDocumentItemRID, list[0].id, params, callback);
    }

    return _this;
  },

  printConsolidationBox: function printConsolidationBox(RID) {
    var _this = this;

    app.getFormation('printing:consolidation_box', { RID: RID }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewPrintMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  printConsolidationBoxes: function printConsolidationBoxes(ConsolidationgBatchRID, DeliveryNoteRIDs) {
    var _this = this;

    app.getFormation('printing:consolidation_boxes', { ConsolidationgBatchRID: ConsolidationgBatchRID, DeliveryNoteRIDs: DeliveryNoteRIDs }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewPrintMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  printConsolidationBoxArticle: function printConsolidationBoxArticle(RID, count) {
    var _this = this;

    app.getFormation('printing:consolidation_box_article', { RID: RID, Count: count }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewPrintMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});

